import { innerSearch } from 'api/Api';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useMutation } from 'react-query';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

//결제 응답
const ConfirmPage = () => {
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState, setShopifyState } = usePaymentState();
  const [paramTid, setParamTid] = useState<string>('');
  const [returnUrl, setReturnUrl] = useState<string>('');

  useEffect(() => {
    if (!isMobile) {
      window.close();
    }
  }, []);

  useEffect(() => {
    const tid = new URLSearchParams(searchParams).get('tid');
    if (tid) {
      setParamTid(tid);
    }
    // if (returnUrl) {
    //   setReturnUrl(returnUrl);
    // }
  }, [searchParams]);

  useEffect(() => {
    if (paramTid) {
      setPaymentState(prevState => ({
        ...prevState,
        tid: paramTid,
        // returnUrl: returnUrl,
      }));
      transactResult.mutate();
    }
  }, [paramTid]);

  const updatePaymentState = infoData => {
    setPaymentState(prevState => ({
      ...prevState,
      requestCurrency: infoData.display.requestCurrency,
      requestAmount: infoData.display.requestAmount,
      reqDate: infoData.display.responseDatetime,
      orderId: infoData.response.orderId,
      resultCode: infoData.response.resultCode,
      resultMessage: infoData.response.resultMessage,
      mallReserved: infoData.response.mallReserved,
      billKey: infoData.response.billKey,
      schemeGroup: infoData.response.schemeGroup,
      schemeCode: infoData.response.schemeCode,
    }));
  };

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(paramTid), {
    onSuccess: data => {
      // PaymentState Set
      updatePaymentState(data.data);
      // InnerSearch 결과처리

      if (data.data.returnUrl.includes('shopifyConfirm')) {
        setShopifyState(data.data.response);

        navigate('/shopifyConfirm');
      } else {
        payResult(data);
        // 상태코드 예외처리
        if (
          data.data.response.resultStatus === null ||
          data.data.response.resultStatus === undefined
        ) {
          navigate('/error');
        }
      }
    },
    onError: error => {
      // setLoading(false);
      navigate('/error');
    },
  });

  // 결제 결과 PaymentState set 및 결과화면 처리
  const payResult = data => {
    // 결과 상태
    const resultStatus = String(data.data.response.resultStatus).toLowerCase();
    // 결제 타입
    const payType = String(data.data.display.payType).toLowerCase();
    // InnerSearch 결과 값 PaymentState 설정
    setPaymentState(prevState => ({
      ...prevState,
      resultCode: data.data.response.resultCode,
      resultMessage: data.data.response.resultMessage,
      tid: data.data.response.tid,
      orderId: data.data.response.orderId,
      mallReserved: data.data.response.mallReserved,
      billKey: data.data.response.billKey,
      returnUrl: data.data.returnUrl,
      descriptor: data.data.display.descriptor,
      schemeGroup: data.data.response.schemeGroup,
      schemeCode: data.data.response.schemeCode,
    }));
    // Status에 따른 Paging 처리
    switch (resultStatus) {
      case 'success':
        navigate('/success');
        break;
      case 'decline':
        navigate('/decline');
        break;
      case 'processing':
        navigate('/processing');
        break;
      case 'pending':
        payType === 'vbank' || payType === 'otc'
          ? navigate('/vbankPending')
          : navigate('/pending');
        break;
      case 'failed':
        navigate('/failed');
        break;
      default:
        navigate('/error');
    }
  };
  return null;
};

export default ConfirmPage;
